import DetailsPageTitle from "components/common/DetailsPageTitle";
import Spinners from "components/common/Spinners";
import React, { useEffect } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getAPILogDetails } from "store/actions/globalSettingSlice";
import { Tabs, Tab } from "react-bootstrap";
import { showAlert } from "store/reducers/alertReducer";
import { Copy, Download } from "lucide-react";

const APILogsDetails = () => {
  const { t } = useTranslation();
  document.title = t("API Logs Details | Work Space");

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const dispatch = useDispatch();
  const { loading, isLoading, apiLogsDetails } = useSelector(
    (state) => state.GlobalSettings
  );

  useEffect(() => {
    dispatch(getAPILogDetails(id));
  }, []);

  const formattedData = (data) => data?.replace(/\n/g, "<br>");

  const copyToClipboard = (data) => {
    const dataString = JSON.stringify(data, null, 2);

    const textarea = document.createElement("textarea");
    textarea.value = dataString;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);

    try {
      textarea.select();
      const successful = document.execCommand("copy");
      if (successful) {
        dispatch(
          showAlert({ text: t("Data copied to clipboard!"), type: "success" })
        );
      } else {
        dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }));
      }
    } catch (err) {
      dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }));
    } finally {
      document.body.removeChild(textarea);
    }
  };

  const downloadJSON = (data) => {
    const dataString = JSON.stringify(data, null, 2);
    const blob = new Blob([dataString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "data.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <React.Fragment>
      <div className="page-content common_details_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("API Log Details")} />
            </Row>
            <div className="common_wrapper">
              <Row>
                <Col lg={12}>
                  <div className="common_card_inner price_details">
                    <h2 className="fs_20 text_black mb-2">
                      {t("Customer Device Information")}
                    </h2>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Model")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.model || "-"}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Platform")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.platform || "-"}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Device Id")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.deviceId || "-"}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("App Version")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.appVersion ||
                          "-"}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("OS Version	")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.osVersion || "-"}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Language")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.language || "-"}
                      </h2>
                    </div>
                    {/* <div className="g_between mt-2 gap-3">
                      <h2 className="fs_14 w_fit_content">{t("FCM Token")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.deviceInfo?.fcmToken || "-"}
                      </h2>
                    </div> */}
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="common_card_inner price_details">
                    <h2 className="fs_20 text_black mb-2">
                      {t("Customer Details")}
                    </h2>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Id")}</h2>
                      <h2 className="fs_14">{apiLogsDetails?._id}</h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Customer Name")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.name}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Customer Phone Number")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.userInfo?.phone}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Date & Time")}</h2>
                      <h2 className="fs_14">{apiLogsDetails?.createdAt}</h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Method")}</h2>
                      <h2 className="fs_14">{apiLogsDetails?.data?.method}</h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("IP Address")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.data?.ipAddress}
                      </h2>
                    </div>
                    <div className="g_between mt-2 gap-3">
                      <h2 className="fs_14">{t("Path")}</h2>
                      <h2 className="fs_14 overflow-auto w-100">
                        {apiLogsDetails?.data?.url}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Status Code")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.data?.responseStatus}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Duration")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.data?.duration}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Memory Usage")}</h2>
                      <h2 className="fs_14">
                        {apiLogsDetails?.data?.memoryUsed}
                      </h2>
                    </div>
                    <div className="g_between mt-2">
                      <h2 className="fs_14">{t("Status")}</h2>
                      {apiLogsDetails?.data?.responseStatus &&
                      apiLogsDetails?.data?.status === 1 ? (
                        <Badge className="bg-success">{t("Success")}</Badge>
                      ) : (
                        <Badge className="bg-danger">{t("Failed")}</Badge>
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <Tabs
                    defaultActiveKey="payload"
                    id="custom-tabs"
                    className="mb-3 mt-3"
                  >
                    <Tab eventKey="payload" title="Payload">
                      <div
                        className="bg-black text-white p-3 rounded-4 position-relative"
                        style={{ maxHeight: 600, overflowY: "auto" }}
                      >
                        <pre
                          dangerouslySetInnerHTML={{
                            __html: formattedData(
                              JSON.stringify(
                                apiLogsDetails?.data?.requests,
                                null,
                                2
                              )
                            ),
                          }}
                        />

                        <Copy
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 55,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            copyToClipboard(apiLogsDetails?.data?.requests)
                          }
                        />

                        <Download
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            downloadJSON(apiLogsDetails?.data?.requests)
                          }
                        />
                      </div>
                    </Tab>

                    <Tab eventKey="header" title="Header">
                      <div
                        className="bg-black text-white p-3 rounded-4 position-relative"
                        style={{ maxHeight: 600, overflowY: "auto" }}
                      >
                        <pre
                          dangerouslySetInnerHTML={{
                            __html: formattedData(
                              JSON.stringify(
                                apiLogsDetails?.data?.headers,
                                null,
                                2
                              )
                            ),
                          }}
                        />
                        <Copy
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 55,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            copyToClipboard(apiLogsDetails?.data?.headers)
                          }
                        />
                        <Download
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            downloadJSON(apiLogsDetails?.data?.headers)
                          }
                        />
                      </div>
                    </Tab>

                    <Tab eventKey="response" title="Response">
                      <div
                        className="bg-black text-white p-3 rounded-4 position-relative"
                        style={{ maxHeight: 600, overflowY: "auto" }}
                      >
                        <pre
                          dangerouslySetInnerHTML={{
                            __html: formattedData(
                              JSON.stringify(
                                apiLogsDetails?.data?.response,
                                null,
                                2
                              )
                            ),
                          }}
                        />
                        <Copy
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 55,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            copyToClipboard(apiLogsDetails?.data?.response)
                          }
                        />
                        <Download
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            downloadJSON(apiLogsDetails?.data?.response)
                          }
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </Col>
              </Row>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default APILogsDetails;
